var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toggle",class:[_vm.state_class]},[_c('div',{staticClass:"draggable",style:(_vm.style),on:{"touchmove":function($event){$event.preventDefault();return _vm.dragStart.apply(null, arguments)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }